import { render, staticRenderFns } from "./YijingDialog.vue?vue&type=template&id=ef575174&scoped=true"
import script from "./YijingDialog.vue?vue&type=script&lang=js"
export * from "./YijingDialog.vue?vue&type=script&lang=js"
import style0 from "./YijingDialog.vue?vue&type=style&index=0&id=ef575174&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef575174",
  null
  
)

export default component.exports